import React, { useState, useEffect } from "react";
import { Container, Grid, Link, Table, TableBody, TableHead, TableRow } from "@mui/material";
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import BubbleChartIcon from '@mui/icons-material/BubbleChart';
import Web3 from "web3";

import dapp_logo from '../image/dapp_logo.png'
import holder from '../image/holder.png'
import lives from '../image/lives.png'
import homeIcon from '../image/homeIcon.png'

var web3;
var address;
var abi;
var gameContract;
var tokenContract;
var rewAdd;
var rewAbi;
var rewAddCont;
var rewABICont;
var accounts = [];
let finalAccount;
var nf = new Intl.NumberFormat();
var countVal = 0
const sortingdataar = []
let client;
var stringDymainArrayLoop;
//new data
let reptileListItems;
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '80%',
    maxWidth:"400px",
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    backgroundImage: "linear-gradient(-45deg, #FFB347, #FFC03D, #FFCC33)",
    border: '5px solid #FFB347',
    borderRadius: 10,
    padding: '60px 20px'
  };
  const Dashboard = () => {
   
    const [useUserBalance,setUserBalance] = useState();
    const [usePool,setPool] = useState();
    const [useUserLives,setUserLives] = useState(0);
    const [useApproveBTN, setApproveBTN] = useState('')
    const [useLockBTNsection, setLockBTNsection] = useState('d-none')
    const [useLockBTN, setLockBTN] = useState('d-none')
    const [useDashboardError, setDashboardError] = useState('d-none')
    const [useWalletError, setWalletError] = useState('d-block')
    const [usePlayBTN, setPlayBTN] = useState('d-none')
    const [usetestingState, settestingState] = useState([]);
    const [useUserScore, setUserScore] = useState([]);
    const [useWalletBtnText, setWalletBtnText] = useState('Connect Wallet');
    const [useWalletBtnAdd, setWalletBtnAdd] = useState('');
    const [useLoader, setLoader] = React.useState('d-none');
    const [open, setOpen] = React.useState(false);
    const [useLiveAmount, setLiveAmount] = useState(1);

    
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    function financial(num,digit) {
        return Number.parseFloat(num).toFixed(digit);
    }

    useEffect(()=> {
        connectWallat();
        leaderboardData();
        // const interval = setInterval(() => {
        //     leaderboardData();
        //   }, 30000);
        
        //   return () => clearInterval(interval); 
    },[usetestingState]);

    const leaderboardData = () => {
        
        console.log('reloading data..!')
        fetch("https://puppshibba.herokuapp.com/topten")
            .then(response => response.json())
            .then(json => {
                    console.log(json)
                    reptileListItems = json.map(function(i,j){
                        return (
                            <TableRow>
                                <td className="text-left py-2 pl-lg-3">
                                    {hideAdd(i.address)}
                                    <br />
                                    {ordinal_suffix_of(j+1)} Position
                                </td>
                                <td className="text-right py-2 pr-lg-3">
                                    {i.Score}
                                    <br />
                                    <span>
                                        <span>{j+1}</span>
                                    </span>
                                </td>
                            </TableRow>
                        );
                    });

            });
    }
    const remainingLives = (x) => {
        fetch("https://puppshibba.herokuapp.com/findone/" + x)
            .then(response => response.json())
            .then(json => {
                if(json.lives>0){
                    setUserLives(json.lives)
                    setLockBTN('d-none')
                    setPlayBTN('d-block')
                }else{
                    setUserLives(0)
                    setPlayBTN('d-none')
                    setLockBTN('d-block')
                }
                setUserScore(json.Score)
            });
    }
    /*******
    *
    *    Connecting Metamask
    *    Creating Contract object
    *    Save Wallet address in varibale
    *
    ******/
     const  connectWallat = () =>{
        handleOpen()
        //if metamask is installed
        if(window.web3 !== undefined){
            
            //connect to web3
            var stepFinished = false;
            web3 = new Web3(window.ethereum);
            // Token Conract
            rewAdd = '0x8203612382f61baFaE549fBF31eFbf70992fA289';  //real contract
            // rewAdd = '0x232e68599c868728f84B7eD96Afc05a51d16F514';
            
            rewAbi = [{"inputs":[],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"minTokensBeforeSwap","type":"uint256"}],"name":"MinTokensBeforeSwapUpdated","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"tokensSwapped","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"ethReceived","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"tokensIntoLiqudity","type":"uint256"}],"name":"SwapAndLiquify","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"bool","name":"enabled","type":"bool"}],"name":"SwapAndLiquifyEnabledUpdated","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"inputs":[],"name":"BNBBalance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"_liquidityFee","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"_maxTxAmount","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"_taxFee","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"spender","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"changeLimit","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"subtractedValue","type":"uint256"}],"name":"decreaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"tAmount","type":"uint256"}],"name":"deliver","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"excludeFromFee","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"excludeFromReward","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"exist","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_sender","type":"address"}],"name":"expectedRewards","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"geUnlockTime","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"includeInFee","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"includeInReward","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"addedValue","type":"uint256"}],"name":"increaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"isExcludedFromFee","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"isExcludedFromReward","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"limit","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"time","type":"uint256"}],"name":"lock","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"myRewards","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"numberOfTokenHolders","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"pancakePair","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"pancakeRouter","outputs":[{"internalType":"contract IPancakeRouter02","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tAmount","type":"uint256"},{"internalType":"bool","name":"deductTransferFee","type":"bool"}],"name":"reflectionFromToken","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"liquidityFee","type":"uint256"}],"name":"setLiquidityFeePercent","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"maxTxPercent","type":"uint256"}],"name":"setMaxTxPercent","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"bool","name":"_enabled","type":"bool"}],"name":"setSwapAndLiquifyEnabled","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"taxFee","type":"uint256"}],"name":"setTaxFeePercent","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"swapAndLiquifyEnabled","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"rAmount","type":"uint256"}],"name":"tokenFromReflection","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"","type":"uint256"}],"name":"tokenHolder","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalFees","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"sender","type":"address"},{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"unlock","outputs":[],"stateMutability":"nonpayable","type":"function"},{"stateMutability":"payable","type":"receive"}];
            tokenContract = new web3.eth.Contract(rewAbi, rewAdd);
            
            // game conract of Shibapup Token
            // address = '0x20267958deE10a783d33f85Df15D594e765A6B78';
            // abi = [
            //     {
            //         "anonymous": false,
            //         "inputs": [
            //             {
            //                 "indexed": true,
            //                 "internalType": "address",
            //                 "name": "previousOwner",
            //                 "type": "address"
            //             },
            //             {
            //                 "indexed": true,
            //                 "internalType": "address",
            //                 "name": "newOwner",
            //                 "type": "address"
            //             }
            //         ],
            //         "name": "OwnershipTransferred",
            //         "type": "event"
            //     },
            //     {
            //         "inputs": [
            //             {
            //                 "internalType": "address payable",
            //                 "name": "user",
            //                 "type": "address"
            //             }
            //         ],
            //         "name": "addWinner",
            //         "outputs": [],
            //         "stateMutability": "nonpayable",
            //         "type": "function"
            //     },
            //     {
            //         "inputs": [],
            //         "name": "emergencyWithdraw",
            //         "outputs": [],
            //         "stateMutability": "nonpayable",
            //         "type": "function"
            //     },
            //     {
            //         "inputs": [],
            //         "name": "participate",
            //         "outputs": [],
            //         "stateMutability": "payable",
            //         "type": "function"
            //     },
            //     {
            //         "inputs": [],
            //         "name": "releaseRewards",
            //         "outputs": [],
            //         "stateMutability": "nonpayable",
            //         "type": "function"
            //     },
            //     {
            //         "inputs": [
            //             {
            //                 "internalType": "address payable",
            //                 "name": "user",
            //                 "type": "address"
            //             }
            //         ],
            //         "name": "removeWinner",
            //         "outputs": [],
            //         "stateMutability": "nonpayable",
            //         "type": "function"
            //     },
            //     {
            //         "inputs": [],
            //         "name": "renounceOwnership",
            //         "outputs": [],
            //         "stateMutability": "nonpayable",
            //         "type": "function"
            //     },
            //     {
            //         "inputs": [],
            //         "name": "resetContract",
            //         "outputs": [],
            //         "stateMutability": "nonpayable",
            //         "type": "function"
            //     },
            //     {
            //         "inputs": [
            //             {
            //                 "internalType": "uint256",
            //                 "name": "value",
            //                 "type": "uint256"
            //             }
            //         ],
            //         "name": "setMinimalParticipation",
            //         "outputs": [],
            //         "stateMutability": "nonpayable",
            //         "type": "function"
            //     },
            //     {
            //         "inputs": [
            //             {
            //                 "internalType": "uint256",
            //                 "name": "value",
            //                 "type": "uint256"
            //             }
            //         ],
            //         "name": "setWinnersAmount",
            //         "outputs": [],
            //         "stateMutability": "nonpayable",
            //         "type": "function"
            //     },
            //     {
            //         "inputs": [
            //             {
            //                 "internalType": "address",
            //                 "name": "newOwner",
            //                 "type": "address"
            //             }
            //         ],
            //         "name": "transferOwnership",
            //         "outputs": [],
            //         "stateMutability": "nonpayable",
            //         "type": "function"
            //     },
            //     {
            //         "inputs": [
            //             {
            //                 "internalType": "contract IERC20",
            //                 "name": "token",
            //                 "type": "address"
            //             }
            //         ],
            //         "name": "withdrawERC20",
            //         "outputs": [],
            //         "stateMutability": "nonpayable",
            //         "type": "function"
            //     },
            //     {
            //         "inputs": [
            //             {
            //                 "internalType": "uint256",
            //                 "name": "_winners_amount",
            //                 "type": "uint256"
            //             },
            //             {
            //                 "internalType": "uint256",
            //                 "name": "_minimal_participation",
            //                 "type": "uint256"
            //             }
            //         ],
            //         "stateMutability": "nonpayable",
            //         "type": "constructor"
            //     },
            //     {
            //         "inputs": [],
            //         "name": "balance",
            //         "outputs": [
            //             {
            //                 "internalType": "uint256",
            //                 "name": "",
            //                 "type": "uint256"
            //             }
            //         ],
            //         "stateMutability": "view",
            //         "type": "function"
            //     },
            //     {
            //         "inputs": [],
            //         "name": "minimal_participation",
            //         "outputs": [
            //             {
            //                 "internalType": "uint256",
            //                 "name": "",
            //                 "type": "uint256"
            //             }
            //         ],
            //         "stateMutability": "view",
            //         "type": "function"
            //     },
            //     {
            //         "inputs": [],
            //         "name": "owner",
            //         "outputs": [
            //             {
            //                 "internalType": "address",
            //                 "name": "",
            //                 "type": "address"
            //             }
            //         ],
            //         "stateMutability": "view",
            //         "type": "function"
            //     },
            //     {
            //         "inputs": [],
            //         "name": "players",
            //         "outputs": [
            //             {
            //                 "internalType": "uint256",
            //                 "name": "",
            //                 "type": "uint256"
            //             }
            //         ],
            //         "stateMutability": "view",
            //         "type": "function"
            //     },
            //     {
            //         "inputs": [
            //             {
            //                 "internalType": "uint256",
            //                 "name": "",
            //                 "type": "uint256"
            //             }
            //         ],
            //         "name": "playersArray",
            //         "outputs": [
            //             {
            //                 "internalType": "address payable",
            //                 "name": "",
            //                 "type": "address"
            //             }
            //         ],
            //         "stateMutability": "view",
            //         "type": "function"
            //     },
            //     {
            //         "inputs": [
            //             {
            //                 "internalType": "uint256",
            //                 "name": "",
            //                 "type": "uint256"
            //             }
            //         ],
            //         "name": "registered_players",
            //         "outputs": [
            //             {
            //                 "internalType": "address payable",
            //                 "name": "",
            //                 "type": "address"
            //             }
            //         ],
            //         "stateMutability": "view",
            //         "type": "function"
            //     },
            //     {
            //         "inputs": [],
            //         "name": "winners_amount",
            //         "outputs": [
            //             {
            //                 "internalType": "uint256",
            //                 "name": "",
            //                 "type": "uint256"
            //             }
            //         ],
            //         "stateMutability": "view",
            //         "type": "function"
            //     }
            // ];
            address = '0x0ADdb4E5F0bcD3919864BF53f4d630aa45879b30';
            abi = [
                {
                    "inputs": [
                        {
                            "internalType": "uint256",
                            "name": "_winners_amount",
                            "type": "uint256"
                        },
                        {
                            "internalType": "uint256",
                            "name": "_minimal_participation",
                            "type": "uint256"
                        }
                    ],
                    "stateMutability": "nonpayable",
                    "type": "constructor"
                },
                {
                    "anonymous": false,
                    "inputs": [
                        {
                            "indexed": true,
                            "internalType": "address",
                            "name": "previousOwner",
                            "type": "address"
                        },
                        {
                            "indexed": true,
                            "internalType": "address",
                            "name": "newOwner",
                            "type": "address"
                        }
                    ],
                    "name": "OwnershipTransferred",
                    "type": "event"
                },
                {
                    "inputs": [
                        {
                            "internalType": "address payable",
                            "name": "user",
                            "type": "address"
                        }
                    ],
                    "name": "addWinner",
                    "outputs": [],
                    "stateMutability": "nonpayable",
                    "type": "function"
                },
                {
                    "inputs": [],
                    "name": "balance",
                    "outputs": [
                        {
                            "internalType": "uint256",
                            "name": "",
                            "type": "uint256"
                        }
                    ],
                    "stateMutability": "view",
                    "type": "function"
                },
                {
                    "inputs": [],
                    "name": "emergencyWithdraw",
                    "outputs": [],
                    "stateMutability": "nonpayable",
                    "type": "function"
                },
                {
                    "inputs": [],
                    "name": "minimal_participation",
                    "outputs": [
                        {
                            "internalType": "uint256",
                            "name": "",
                            "type": "uint256"
                        }
                    ],
                    "stateMutability": "view",
                    "type": "function"
                },
                {
                    "inputs": [],
                    "name": "owner",
                    "outputs": [
                        {
                            "internalType": "address",
                            "name": "",
                            "type": "address"
                        }
                    ],
                    "stateMutability": "view",
                    "type": "function"
                },
                {
                    "inputs": [],
                    "name": "participate",
                    "outputs": [],
                    "stateMutability": "payable",
                    "type": "function"
                },
                {
                    "inputs": [],
                    "name": "players",
                    "outputs": [
                        {
                            "internalType": "uint256",
                            "name": "",
                            "type": "uint256"
                        }
                    ],
                    "stateMutability": "view",
                    "type": "function"
                },
                {
                    "inputs": [
                        {
                            "internalType": "uint256",
                            "name": "",
                            "type": "uint256"
                        }
                    ],
                    "name": "playersArray",
                    "outputs": [
                        {
                            "internalType": "address payable",
                            "name": "",
                            "type": "address"
                        }
                    ],
                    "stateMutability": "view",
                    "type": "function"
                },
                {
                    "inputs": [
                        {
                            "internalType": "uint256",
                            "name": "",
                            "type": "uint256"
                        }
                    ],
                    "name": "registered_players",
                    "outputs": [
                        {
                            "internalType": "address payable",
                            "name": "",
                            "type": "address"
                        }
                    ],
                    "stateMutability": "view",
                    "type": "function"
                },
                {
                    "inputs": [],
                    "name": "releaseRewards",
                    "outputs": [],
                    "stateMutability": "nonpayable",
                    "type": "function"
                },
                {
                    "inputs": [
                        {
                            "internalType": "address payable",
                            "name": "user",
                            "type": "address"
                        }
                    ],
                    "name": "removeWinner",
                    "outputs": [],
                    "stateMutability": "nonpayable",
                    "type": "function"
                },
                {
                    "inputs": [],
                    "name": "renounceOwnership",
                    "outputs": [],
                    "stateMutability": "nonpayable",
                    "type": "function"
                },
                {
                    "inputs": [],
                    "name": "resetContract",
                    "outputs": [],
                    "stateMutability": "nonpayable",
                    "type": "function"
                },
                {
                    "inputs": [
                        {
                            "internalType": "uint256",
                            "name": "value",
                            "type": "uint256"
                        }
                    ],
                    "name": "setMinimalParticipation",
                    "outputs": [],
                    "stateMutability": "nonpayable",
                    "type": "function"
                },
                {
                    "inputs": [
                        {
                            "internalType": "uint256",
                            "name": "value",
                            "type": "uint256"
                        }
                    ],
                    "name": "setWinnersAmount",
                    "outputs": [],
                    "stateMutability": "nonpayable",
                    "type": "function"
                },
                {
                    "inputs": [
                        {
                            "internalType": "address",
                            "name": "newOwner",
                            "type": "address"
                        }
                    ],
                    "name": "transferOwnership",
                    "outputs": [],
                    "stateMutability": "nonpayable",
                    "type": "function"
                },
                {
                    "inputs": [],
                    "name": "winners_amount",
                    "outputs": [
                        {
                            "internalType": "uint256",
                            "name": "",
                            "type": "uint256"
                        }
                    ],
                    "stateMutability": "view",
                    "type": "function"
                },
                {
                    "inputs": [
                        {
                            "internalType": "contract IERC20",
                            "name": "token",
                            "type": "address"
                        }
                    ],
                    "name": "withdrawERC20",
                    "outputs": [],
                    "stateMutability": "nonpayable",
                    "type": "function"
                }
            ];
            gameContract = new web3.eth.Contract(abi, address);
            
            window.ethereum.request({ method: 'eth_requestAccounts' }).then(_accounts => {
                accounts = _accounts;
                finalAccount = accounts.toString();
                setWalletBtnAdd(hideAdd(finalAccount))
                setWalletBtnText('Connected')
                handleClose()
                remainingLives(finalAccount)
                web3.eth.getBalance(address).then(conBalance => {
                    setPool(financial(conBalance/1e18,2))
                });

                // try {
                //      client = new W3CWebSocket("ws://149.56.111.92:1213/shibapupgame");

                //     if(client != null){
                //         setDashboardError('d-none')
                //         setWalletError('d-none')
                //         handleClose();
                //         client.onopen = () => {
                //             if(client.readyState == 1){
                //             console.log("Onopen error: ",client.readyState)
                //                                 client.send(finalAccount);
                //                                 client.send("scoresArray");
                //             }else{
                //                 console.log('Connect is not working.', client)
                //             }
                //         };
                //         client.onmessage = (message) => {
                //             if(!stepFinished){
                //                 stepFinished = true;
                //             }else{
                //                 const userDate = message.data.split(',');
                //                 if (countVal==0){  // getting data for user score
                                    
                //                     countVal++;
                //                 }else if(countVal == 1){
                //                     let userDates = Array()
                //                     userDates = message.data.split(/[:,]+/);
                //                     var d = [];
                //                     var groups = [];
                //                     var stringD = [];
                                    
                //                     for (let i = 0; i <= userDates.length; i = i+1) { 
                //                         if(i < userDates.length ){
                //                             d.push(formatedDataFunc(userDates[i]))
                //                             stringD = JSON.stringify(d)
                //                         }else{
                //                             loopingTest(d)
                //                         }
                //                     }  
                //                     countVal++;
                //                 }
    
                //             }
                //         }
                //     }
                // } catch (error) {
                //     setDashboardError('d-block');
                //     setWalletError('d-none');
                //     handleOpen();
                //     console.log("Error occurred on main connectivity.", error);
                // }
                    
                tokenContract.methods.allowance(finalAccount,address).call().then( result => {
                    if( result > 1 ){
                      setApproveBTN('d-none')
                      setLockBTNsection('d-block')
                    }else{
                      setApproveBTN('d-block')
                      setLockBTNsection('d-none')
                    }
                  })
                
                tokenContract.methods.balanceOf(finalAccount).call().then( result => {
                    setUserBalance(financial(result/1e18,2));
                });
                // to be used 
                tokenContract.methods.balanceOf(address).call().then( result => {
                    setPool(financial(result/1e18,2));
                });
                gameContract.methods.minimal_participation().call().then( valueParticipent => {
                    setLiveAmount(valueParticipent/1e18);
                });
            });  
        }
        else{
            //if Metamask is not installed
            console.log('wallet is not connected')
        }
    }
    // let  testdata = 0;
    // const loopTesting;
    function compare( a, b ) {
        if (b[0] === a[0]) {
            return 0;
        }
        else {
            return (b[0] < a[0]) ? -1 : 1;
        }
      }
    const loopingTest = (x) => {
        var mainArrayLoop = [];
        for(var i = 0; i < x.length; i += 2) {
            mainArrayLoop.push(x.slice(i, i + 2));
            var stringDy = JSON.stringify(mainArrayLoop)
            stringDymainArrayLoop = JSON.stringify(mainArrayLoop)
            settestingState(mainArrayLoop)
        }
    }
    const hideAdd = (x) => {
        const start_char = x.toString().substring(0,5)+".....";
        const end_char = x.toString().substr(x.length - 4);
        return(start_char+end_char)
    }
    const ordinal_suffix_of = (i) => {
        var j = i % 10,
            k = i % 100;
        if (j == 1 && k != 11) {
            return i + "st";
        }
        if (j == 2 && k != 12) {
            return i + "nd";
        }
        if (j == 3 && k != 13) {
            return i + "rd";
        }
        return i + "th";
    }
    //   const reptileListItems = usetestingState.map(function(i,j){
    //     return (
    //         <TableRow>
    //             <td className="text-left py-2 pl-lg-3">
    //                 {hideAdd(i[0])}
    //                 <br />
    //                 {ordinal_suffix_of(j+1)} Position
    //             </td>
    //             <td className="text-right py-2 pr-lg-3">
    //                 {i[1]}
    //                 <br />
    //                 <span>
    //                     <span>{j+1}</span>
    //                 </span>
    //             </td>
    //         </TableRow>
    //     );
    // });
    const formatedDataFunc = (x) => {
        return x.replace(/[^0-9a-zA-Z ]/g, "");
    }
    const handleApprove = () => {
        // setLoader('block');
        setLoader('d-flex')
        tokenContract.methods.approve(address, '115792089237316195423570985008687907853269984665640564039457584007913129639935')
        .send({from: finalAccount}).then( test => {
            tokenContract.methods.allowance(finalAccount,address).call().then( result => {
            // setLoader('none');
            if( result > 1 ){
              setApproveBTN('d-none')
              setLockBTNsection('d-block')
            }else{
              setApproveBTN('d-block')
              setLockBTNsection('d-none')
            }   
            setLoader('d-none')     
          })
        })
        .catch(error => {
            setLoader('d-none')
          console.log('Getting Errors: ' , error);
        });
    }
    const buyNow = () => {  
        fetch("https://puppshibba.herokuapp.com/findone/" + finalAccount)
            .then(response => response.json())
            .then(json => {
                if(json.message != "Address does not exist"){
                    gameContract.methods.minimal_participation().call().then( valueParticipent => {
                        setLoader('d-flex')
                        gameContract.methods.participate()
                        .send({from: finalAccount})
                        .then( participateResult => {
                          async function lskdfjf () {
                                var useridfromapi = "https://puppshibba.herokuapp.com/update/" + json._id
                           await fetch(useridfromapi , {
                                method: "PUT",
                                body: JSON.stringify({
                                    address: finalAccount,
                                    Score: json.Score,
                                    lives: 10,
                                    player: 1
                                }),
                                headers: {
                                    "Content-type": "application/json; charset=UTF-8"
                                }
                            })
                            .then(response => response.json())
                            .then(json => {
                                window.location.reload();
                            });
                            // window.location.reload();
                            setLoader('d-none')
                            }
                            lskdfjf();
                        }).catch(error => {
                            setLoader('d-none')
                              console.log('Error getting Errors: ' , error);
                            });;
                    })
                }else{
                    gameContract.methods.minimal_participation().call().then( valueParticipent => {
                        setLoader('d-flex')
                        gameContract.methods.participate()
                        .send({from: finalAccount})
                        .then( participateResult => {
                            async function lsksssfjdsl(){
                                await fetch("https://puppshibba.herokuapp.com/register", {
                                method: "POST",
                                body: JSON.stringify({
                                    address: finalAccount,
                                    lives: 10,
                                    player: 1
                                }),
                                headers: {
                                    "Content-type": "application/json; charset=UTF-8"
                                }
                            })
                            .then(response => response.json())
                            .then(json => {
                                window.location.reload();
                            });
                            // window.location.reload();
                            setLoader('d-none')
                            }
                            lsksssfjdsl()
                        }).catch(error => {
                            setLoader('d-none')
                              console.log('Error getting Errors: ' , error);
                            });;
                    })
                }

                
            });
        
    }
    
    const addscroes = () => {
        // livesArray
        fetch("https://puppshibba.herokuapp.com/register", {
            method: "POST",
            body: JSON.stringify({
                address: finalAccount,
                lives: 10,
                player: 1
            }),
            headers: {
                "Content-type": "application/json; charset=UTF-8"
            }
        })
        .then(response => response.json())
        .then(json => {
            console.log(json)
            // window.location.reload();
                fetch("https://puppshibba.herokuapp.com/getall", {
                method: "POST",
                body: JSON.stringify({
                    address: finalAccount,
                    lives: 10,
                    player: 1
                }),
                headers: {
                    "Content-type": "application/json; charset=UTF-8"
                }
            })
            .then(response => response.json())
            .then(json => {
                console.log(json)
                window.location.reload();
            });
        });
        
    }
    return(
        <div className="SE---dashboard p-0">
            <div className={"se---loader " + useLoader}>
            {/* <div className={"se---loader d-flex"}> */}
                <div className="pt-5">
                    <div className="loading2"></div>
                    <h3 className="d-block text-light text-center mt-4">processing...</h3>
                    <p className="d-block text-light text-center mt-4">Do not refresh while the loader is there</p>
                </div>
            </div>
            {/* <div className="SE---dashboard--dapp"> */}
                <Container maxWidth="xl" className="px-0" style={{maxWidth: 'unset'}}>
                    <Grid
                        container
                        item
                        direction="row"
                        justifyContent="flex-start"
                        alignItems="flex-start"
                    >
                        <Grid
                            item 
                            xs={12}
                            md={1}
                            className="text-center py-0 dapp---home-icon"
                        >
                            <div className="position-relative">
                                <Link href="/" className="">
                                    <img src={dapp_logo} className="img-fluid w-100" style={{maxWidth:100}} />
                                </Link>
                                <Link href="/">
                                    <img src={homeIcon} className="img-fluid w-100" style={{maxWidth:30}} />
                                </Link>
                            </div>
                        </Grid>
                        <Grid
                            item 
                            xs={12}
                            md={1}
                            className="text-center "
                        ></Grid>
                        <Grid
                        item 
                            container
                            direction="row"
                            justifyContent="flex-start"
                            alignItems="flex-start"
                            xs={12}
                            md={11}
                            className="SE---dashboard--dapp px-md-5 pb-5"
                        >
                            <Grid
                                xs={12}
                                className="text-center text-sm-right py-4"
                            >
                                {/* <Link href="https://www.shibapup.dog/game" className="Global---menu-nav-btn game px-4 px-sm-5 py-2 btn d-inline-block mx-2">
                                    
                                    <span style={{fontSize:14}} >Play Game</span>
                                </Link> */}
                                <Link href="#" className="Global---menu-nav-btn px-4 mt-3 mt-ms-0 px-sm-3 py-2 btn d-inline-block mx-2" onClick={connectWallat} >
                                    <span style={{fontSize:14}} className="mx-2" >{useWalletBtnText}</span>
                                    <span style={{fontSize:12}}>{useWalletBtnAdd}</span>
                                </Link>
                            </Grid>
                            <Grid
                                container
                                direction="row"
                                justifyContent="flex-start"
                                alignItems="flex-start"
                                xs={12}
                                sm={6}
                                className="px-3"
                            >
                                <Grid
                                    xs={12}
                                    md={6}
                                    className="my-3 pr-md-3"
                                >
                                    <div className="SE---dashboard_background SE---dashboard_minicard">
                                        <h6>Shiba pup's holding</h6>
                                        <div className="d-flex mt-3">
                                            <img src={holder} style={{maxWidth:50}} />
                                            <p className="mb-0 mt-3 ml-2">{useUserBalance}</p>
                                        </div>
                                    </div>
                                </Grid>
                                <Grid
                                    xs={12}
                                    md={6}
                                    className="my-3 pl-md-3"
                                >
                                    <div className="SE---dashboard_background SE---dashboard_minicard">
                                        <h6>Remaining lives</h6>
                                        <div className="d-flex mt-3">
                                            <img src={lives} style={{maxWidth:50}} />
                                            <p className="mb-0 mt-3 ml-2">{useUserLives}</p>
                                        </div>
                                    </div>
                                </Grid>
                                <Grid
                                    xs={12}
                                    className="SE---dashboard_background my-3 bg-light text-center"
                                >
                                    <h4>Buy Lives</h4>
                                    <p className="text-left">You can buy 10 lives for {useLiveAmount} shibapup.</p>
                                    <div className="text-left">
                                        
                                        { useUserBalance > 1 ? 
                                            <div>
                                                <div>
                                                    <button className={useApproveBTN + " mt-4 py-4"} onClick={handleApprove}>Approve</button>
                                                </div>
                                                <div className={useLockBTNsection} >
                                                    <button className={useLockBTN + " mt-4 py-4"} style={{fontSize: 20}} onClick={buyNow}>Buy</button>
                                                </div>
                                                <div>
                                                    <a href="https://www.shibapup.dog/game" className={usePlayBTN + " Global---menu-nav-btn text-center mt-4 py-4"} style={{fontSize: 20}}>Play Now</a>
                                                </div>
                                            </div>
                                        : 
                                            <div>
                                                <p className="mb-2 text-danger" style={{fontSize:13}}>You have insufficient Shibapup.</p>
                                                <div className="d-md-flex justify-content-between">
                                                    <Link 
                                                        href="https://pancakeswap.finance/swap#/swap?inputCurrency=0x8203612382f61bafae549fbf31efbf70992fa289"
                                                        className="SP---header--buy-btn PCS dapp-btn d-block d-md-inline-block  btn px-3 py-2 mb-4"
                                                        target="_blank"
                                                    >
                                                        Buy on Pancake
                                                    </Link>
                                                    <Link 
                                                        href="https://www.cointiger.com/en-us/#/trade_center?coin=shibapup_usdt" 
                                                        className="SP---header--buy-btn CT dapp-btn d-block d-md-inline-block  btn px-3 py-2 mb-4 ml-md-3"
                                                        target="_blank"
                                                    >
                                                        Buy on CoinTiger
                                                    </Link>
                                                    <Link 
                                                        href="https://www.bitmart.com/trade/en?layout=pro&symbol=SHIBAPUP_USDT" 
                                                        className="SP---header--buy-btn MT dapp-btn d-block d-md-inline-block  btn px-3 py-2 mb-4 ml-md-3"
                                                        target="_blank"
                                                    >
                                                        Buy on BitMart
                                                    </Link>
                                                </div>
                                            </div>
                                        }
                                        
                                        
                                        {/* <div>
                                            <button 
                                                className={ " mt-4 py-4"} 
                                                style={{fontSize: 20}} 
                                                onClick={addscroes}
                                            >
                                                Add Live
                                            </button>
                                        </div> */}
                                    </div>
                                </Grid>
                                <Grid
                                    xs={12}
                                    className="SE---dashboard_background SE---dashboard_leaderboard position-relative my-3"
                                >
                                    <div>
                                        <h4>Leaderboard</h4>
                                        <div className="mt-5 pt-lg-4 px-md-4">
                                            <Table>
                                                <TableHead className="">
                                                    <th className="text-left pl-lg-3">Players</th>
                                                    <th className="text-right pr-lg-3">Score</th>
                                                </TableHead>
                                                <TableBody className="SE---dashboard_row" id="style-3">
                                                    { reptileListItems}
                                                </TableBody>
                                            </Table>
                                            <br />
                                            <Table>
                                                <div className="SE---dashboard_row_last d-flex px-3 py-2">
                                                        <div className="text-left py-2 pl-lg-3">
                                                            <h5 className="mb-0">{hideAdd(accounts)}</h5>
                                                        </div>
                                                        <div className="text-right py-2 pr-lg-3">
                                                            <h5 className="mb-0">{useUserScore}</h5>
                                                        </div>
                                                </div>
                                            </Table>
                                        </div>
                                    </div>
                                </Grid>
                            </Grid>
                            <Grid
                                container
                                direction="row"
                                justifyContent="flex-start"
                                alignItems="flex-start"
                                xs={12}
                                sm={6}
                                className="px-3"
                            >
                                <Grid
                                    xs={12}
                                    className="SE---dashboard_background text-center my-3"
                                >
                                    <h4>Rules</h4>
                                    <p className="text-left mb-2" style={{display: 'flex',alignItems: 'center'}}>
                                        <BubbleChartIcon className="mr-3" />Use the arrow keys to move the pup back and forth
                                    </p>
                                    <p className="text-left mb-2" style={{display: 'flex',alignItems: 'center'}}>
                                        <BubbleChartIcon className="mr-3" />Use the spacebar to jump
                                    </p>
                                    <p className="text-left mb-2" style={{display: 'flex',alignItems: 'center'}}>
                                        <BubbleChartIcon className="mr-3" />Avoid being impaled by spikes or falling off the map. Doing so will cost you a life.
                                    </p>
                                    <p className="text-left mb-2" style={{display: 'flex',alignItems: 'center'}}>
                                        <BubbleChartIcon className="mr-3" />Accumulate the highest score you possibly can to get your spot on the leaderboard. The better you score, the greater your chances of winning amazing rewards!
                                    </p>
                                </Grid>
                                <Grid
                                    xs={12}
                                    className="SE---dashboard_background my-3 text-center"
                                >
                                    <h4 className="text-center">Reward Pool</h4>
                                    <p className="mb-0"><span>{usePool}</span>Shiba pup's</p>
                                </Grid>
                                <Grid
                                    xs={12}
                                    className="SE---dashboard_background SE---dashboard_background_pink my-3"
                                >
                                    <h4 className="text-light">Note :</h4>
                                    <p className="text-left text-light mb-0">Top Three Scorers will get 200 Shiba Pups.</p>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Container>
                <Modal
                    open={open}
                    // onClose={handleClose}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    
                    <Box sx={style}>
                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            Error
                        </Typography>
                         <div className={useDashboardError}>
                            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                                Oops, it seems that your browser is not allowing a connection with the game. Click the button below for further instructions.
                            </Typography>
                            <Link href="https://shibapup.dog/dashboar-doc.pdf" target="_blank" className="Global---menu-nav-btn px-4 mt-3 px-sm-3 py-2 btn d-inline-block" >
                                Instructions
                            </Link>
                        </div>
                         <div className={useWalletError}>
                            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                                Please connect your wallet to see dashboard data.
                            </Typography>
                            <Link href="#" className="Global---menu-nav-btn px-4 mt-3 px-sm-3 py-2 btn d-inline-block" onClick={connectWallat} >
                                Connect Wallet
                            </Link>
                        </div>
                    </Box>
                </Modal>
            {/* </div> */}
        </div>
    )
}
export default Dashboard;